import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KeuanganSaldoComponent } from './saldo/keuangan-saldo.component';
import { KeuanganKomisiComponent } from './komisi/keuangan-komisi.component';
import { DetailRiwayatSaldoComponent } from './components/detail-riwayat-penarikan-saldo/detail-riwayat-penarikan-saldo.component';
import { DetailSaldoComponent } from './components/detail-saldo/detail-saldo.component';
import { DetailKomisiComponent } from './components/detail-komisi/detail-komisi.component';
import { MenuAccessGuard } from 'src/app/guards/menu-access.guard';

const routes: Routes = [
  { path: '', redirectTo: 'balance', pathMatch: 'full' },
  { path: 'balance', component: KeuanganSaldoComponent, canActivate: [MenuAccessGuard] },
  { path: 'commission', component: KeuanganKomisiComponent },
  { path: 'balance/detail/:id', component: DetailRiwayatSaldoComponent },
  { path: 'balance/detail', component: DetailSaldoComponent },
  { path: 'commission/detail', component: DetailKomisiComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KeuanganRoutingModule { }
